const {
    INIT_FILTER,
    INIT_CHECK_FILTER,
    INIT_DATE_FILTER,
    INIT_SELECT_FILTER,
    INIT_AMOUNT_FILTER,
    REMOVE_FILTER,
    REMOVE_CHECK_FILTER,
    REMOVE_DATE_FILTER,
    REMOVE_FILTER_TAG,
    REMOVE_SELECT_FILTER,
    REMOVE_AMOUNT_FILTER,
    SET_APPLIED,
    SET_CHECK_FILTER,
    SET_DATE_FILTER,
    SET_FROM_DATE_FILTER,
    SET_TO_DATE_FILTER,
    SET_SELECT_FILTER,
    SET_MAX_AMOUNT_FILTER,
    SET_MIN_AMOUNT_FILTER
} = require('constants/actionTypes');

const initFilter = (filtersId) => ({
    type: INIT_FILTER,
    filtersId
})

const initCheckFilter = (filtersId, filterId, active, filterType, value, label, isTaggable=true) => ({
    type: INIT_CHECK_FILTER,
    filtersId,
    filterId,
    active,
    filterType,
    value,
    label,
    isTaggable
})

const initDateFilter = (filtersId, filterId, active, selected, filterType, from, to, isTaggable=true) => ({
    type: INIT_DATE_FILTER,
    filtersId,
    filterId,
    active,
    filterType,
    selected,
    from,
    to,
    isTaggable
})

const initSelectFilter = (filtersId, filterId, active, selected, initialSelected, filterType, label, filterTag=undefined, isTaggable=true) => ({
    type: INIT_SELECT_FILTER,
    filtersId,
    filterId,
    active,
    selected,
    initialSelected,
    filterType,
    label,
    filterTag,
    isTaggable
})

const initAmountFilter = (filtersId, filterId, active, filterType, currency, filterTagTo=undefined, filterTagFrom=undefined, isTaggable=true) => ({
    type: INIT_AMOUNT_FILTER,
    filtersId,
    filterId,
    active,
    filterType,
    filterTagTo,
    filterTagFrom,
    currency,
    isTaggable
})

const removeFilter = () => ({
    type: REMOVE_FILTER
})

const removeCheckFilter = (filtersId, filterId) => ({
    type: REMOVE_CHECK_FILTER,
    filtersId,
    filterId
})

const removeFilterDate = (filtersId, filterId) => ({
    type: REMOVE_DATE_FILTER,
    filtersId,
    filterId
})

const removeFilterTag = (filtersId, filterId) => ({
    type: REMOVE_FILTER_TAG,
    filtersId,
    filterId
})

const removeSelectFilter = (filtersId, filterId) => ({
    type: REMOVE_SELECT_FILTER,
    filtersId,
    filterId
})

const removeAmountFilter = (filtersId, filterId) => ({
    type: REMOVE_AMOUNT_FILTER,
    filtersId,
    filterId
})

const setApplied = (filtersId) => ({
    type: SET_APPLIED,
    filtersId
})

const setCheckFilter = (filtersId, filterId, active) => ({
    type: SET_CHECK_FILTER,
    filtersId,
    filterId,
    active
})

const setDateFilter = (filtersId, filterId, active, selected, from, to) => ({
    type: SET_DATE_FILTER,
    filtersId,
    filterId,
    active,
    selected,
    from,
    to
})

const setFromDateFilter = (filtersId, filterId, active, from) => ({
    type: SET_FROM_DATE_FILTER,
    filtersId,
    filterId,
    active,
    from
})

const setToDateFilter = (filtersId, filterId, active, to) => ({
    type: SET_TO_DATE_FILTER,
    filtersId,
    filterId,
    active,
    to
})

const setSelectFilter = (filtersId, filterId, active, selected, label) => ({
    type: SET_SELECT_FILTER,
    filtersId,
    filterId,
    active,
    selected,
    label
})


const setMaxAmountFilter = (filtersId, filterId, value) => ({
    type: SET_MAX_AMOUNT_FILTER,
    filtersId,
    filterId,
    value
})

const setMinAmountFilter = (filtersId, filterId, value) => ({
    type: SET_MIN_AMOUNT_FILTER,
    filtersId,
    filterId,
    value
})

export {
    initFilter,
    initCheckFilter,
    initDateFilter,
    initSelectFilter,
    initAmountFilter,
    removeFilter,
    removeCheckFilter,
    removeFilterDate,
    removeFilterTag,
    removeSelectFilter,
    removeAmountFilter,
    setApplied,
    setCheckFilter,
    setDateFilter,
    setFromDateFilter,
    setToDateFilter,
    setSelectFilter,
    setMaxAmountFilter,
    setMinAmountFilter
}